import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export function useGetPrimaryImage(wireId) {
  const common = v => ({ url: `/api/v1/wire/${v}/primary_image` });
  const [state, q] = useAxios({ ...common(wireId), method: 'GET' }, { manual: true });
  const executeQuery = newId => q(common(newId));
  return [state, executeQuery];
}

export function useAssignPrimaryImage(wireId, imageId) {
  const common = (wId, iId) => ({ url: `/api/v1/wire/${wId}/primary_image/${iId}` });
  const [state, q] = useAxios({ ...common(wireId, imageId), method: 'POST' }, { manual: true });
  const executeQuery = React.useCallback((wId, iId) => q(common(wId, iId)), [q]);
  return [state, executeQuery];
}

// This hook is always called with wireId memoized. No need to provide
// a parameterized query function.
export function useRemovePrimaryImage(wireId) {
  return useAxios({
    url: `/api/v1/wire/${wireId}/primary_image`,
    method: 'DELETE',
  }, { manual: true });
}
